import { forEach, trim } from "lodash-es";
import moment from "moment";

const queryString = require("query-string");

const { $, Rollbar, Pikaday } = window

const requiredAttr = {
  startDate: "",
  startTime: "",
  endDate: "",
  endTime: "",
  reason: "",
  restaurantId: ""
};
let startDatePicker = { destroy: () => { } }
let endDatePicker = { destroy: () => { } }; // mock Pikaday destroy

export function setupBlockForm(container) {
  const selectRestaurant = container.find('.pick_restaurant')
  let selectedRestaurantId
  container.find('.show-after-choose-restaurant').addClass('hidden')
  selectRestaurant.change(() => {
    startDatePicker.destroy()

    selectedRestaurantId = selectRestaurant.val()
    requiredAttr['restaurantId'] = selectedRestaurantId
    $('.start-date-field, .end-date-field').val('')
    container.find('.show-after-choose-restaurant').removeClass('hidden')

    const isFlaggedUrl = $('.is-flagged-url').val()
    $.get(`${isFlaggedUrl}&restaurant_id=${selectedRestaurantId}`).done((flagData) => {
      if (flagData.is_flagged) {
        container.find('.if-flagged').removeClass('hidden')
        container.find('.if-not-flagged').addClass('hidden')
      } else {
        container.find('.if-not-flagged').removeClass('hidden')
        container.find('.if-flagged').addClass('hidden')
      }

      let startDate = new Date();

      if (flagData.is_flagged) {
        requiredAttr['startDate'] = requiredAttr["endDate"] = startDate.toString();
      }

      startDatePicker = new Pikaday({
        field: container.find(".start-date-field")[0],
        minDate: startDate,
        defaultDate: startDate,
        setDefaultDate: false,
        onSelect() {
          requiredAttr["startDate"] = this.toString();

          endDatePicker.destroy();

          setTimeout(() => {
            startDate = startDatePicker.getDate();
            endDatePicker = new Pikaday({
              field: container.find(".end-date-field")[0],
              minDate: startDate,
              defaultDate: startDate,
              setDefaultDate: false,
              maxDate: moment(startDate).add(1, "day").toDate(),
              onSelect() {
                requiredAttr["endDate"] = this.toString();
              }
            });
          }, 1000)
        },
        onClose() {
          startDate = startDatePicker.getDate();
        }
      });
    })
  })
  let options = selectRestaurant.find('option')
  if (options.length == 1) {
    const option = $(options[0])
    option.attr('selected', 'selected')
    selectRestaurant.val(option.attr('value')).change()
  }

  container.find('#select-start-time').change(() => {
    requiredAttr['startTime'] = container.find('#select-start-time').val()
  })

  container.find('#select-end-time').change(() => {
    requiredAttr['endTime'] = container.find('#select-end-time').val()
  })

  container.find('#reason').change(() => {
    requiredAttr['reason'] = container.find('#reason').val()
  })
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function validateBlockForm() {
  let message = "";
  let emptyAttr = [];
  for (let key in requiredAttr) {
    let formattedKey = capitalize(key.replace(/([A-Z])/g, ' $1').trim());
    if (!requiredAttr[key]) {
      emptyAttr.push(formattedKey);
    }
  }

  if (emptyAttr.length > 0) {
    message += "Please fill in " + emptyAttr.join(", ") + ". ";
  }

  return {
    isValid: emptyAttr.length === 0,
    message: message
  }
}

export function submitBlockForm(data, onFinish, onFailed, restaurantIdentifier) {
  let url;
  if ($("#restaurant-group").val() === "1") {
    url = "/dashboard/v2/group/inventories/block";
  } else {
    url = "/dashboard/v2/inventories/block";
  }

  $.ajax({
    url,
    method: "POST",
    data,
    success() {
      onFinish();
      resetAttributes();
    },
    error(response) {
      if (response.responseJSON && response.responseJSON.message) {
        onFailed(response.responseJSON.message);
      }
      Rollbar.error("failed block restaurant", {
        msg: response.message,
        response,
        data,
        restaurantIdentifier
      });
    }
  });
}

export function resetAttributes() {
  requiredAttr.startDate = "";
  requiredAttr.startTime = "";
  requiredAttr.endDate = "";
  requiredAttr.endTime = "";
  requiredAttr.reason = "";
  requiredAttr.restaurantId = "";
}
